import { InfoIcon } from "@justhome/react-ui";
import clsx from "clsx";
import { FC, ReactElement, ReactNode } from "react";

interface MaximumBudgetResultRowProps {
  label: string;
  value: string | ReactElement;
  info?: string | ReactNode;
  isResult?: boolean;
}

const MaximumBudgetResultRow: FC<MaximumBudgetResultRowProps> = ({
  label,
  info,
  value,
  isResult,
}) => {
  return (
    <p
      className={clsx("flex flex-col flex-1 justify-center items-center", {
        "bg-primary-50 py-s text-body-1 font-semibold": isResult,
      })}
    >
      <span className="text-body-2 text-neutral-425">{label}</span>
      <span className="text-body-1 text-primary-800 flex items-center gap-2xs">
        {value}
        {info && <InfoIcon>{info}</InfoIcon>}
      </span>
    </p>
  );
};

export default MaximumBudgetResultRow;
